export const LOCATION_MAP_IFRAME_SANDBOX =
  'allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox' as const;

const IFRAME_BLOCKED_HOSTS = new Set(['maps.app.goo.gl', 'goo.gl']);

const isEmbeddableInIframe = (href: string): boolean => {
  try {
    const url = new URL(href);
    if (url.protocol !== 'https:') return false;
    return !IFRAME_BLOCKED_HOSTS.has(url.hostname);
  } catch {
    return false;
  }
};

const parseTrustedMapHref = (raw: string): string | null => {
  const trimmed = raw?.trim();
  if (!trimmed) return null;

  if (!trimmed.includes('<')) {
    return tryHttpsUrl(trimmed);
  }

  return extractIframeSrcFromHtml(trimmed);
};

export type ResolvedMapDisplay =
  | { kind: 'iframe'; src: string }
  | { kind: 'externalLink'; href: string }
  | null;

export const resolveMapDisplay = (raw: string): ResolvedMapDisplay => {
  const href = parseTrustedMapHref(raw);
  if (!href) return null;
  if (isEmbeddableInIframe(href)) return { kind: 'iframe', src: href };
  return { kind: 'externalLink', href };
};

const tryHttpsUrl = (value: string): string | null => {
  const normalized = value.startsWith('//') ? `https:${value}` : value;
  try {
    const url = new URL(normalized);
    if (url.protocol === 'http:') {
      url.protocol = 'https:';
    }
    if (url.protocol !== 'https:') return null;
    return url.href;
  } catch {
    return null;
  }
};

const extractIframeSrcFromHtml = (html: string): string | null => {
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const iframe = doc.querySelector('iframe');
    const src = iframe?.getAttribute('src')?.trim();
    if (!src) return null;
    return tryHttpsUrl(src);
  } catch {
    return null;
  }
};
